import {EVENTS} from '@helpers/analytics/events'
import {PurchaseTaxonomies} from '@helpers/analytics/events/purchase'
import {sendEvent} from '@helpers/analytics/sendEvents'
import useEventsBaseProperties from '@hooks/useEventsBaseProperties'
import useWebsiteId from '@hooks/useWebsiteId'
import useOptimisticCheckout from '@page-components/CheckoutV3/hooks/useOptimisticCheckout'
import usePreferences from '@page-components/CheckoutV3/hooks/usePreferences.main'
import {useMutate} from 'apollo-hooks'
import gql from 'graphql-tag'

export default function useSetTipAmount() {
  const {preferences} = usePreferences()
  const websiteId = useWebsiteId()
  const mutate = useMutate()
  const {optimisticStart, optimisticEnd} = useOptimisticCheckout()
  const eventBaseProperties = useEventsBaseProperties()

  const {cart, _id} = preferences
  const {calculatedTipAmount, amountToPay} = cart

  async function setTipAmount({amount, onError, onSuccess}) {
    try {
      optimisticStart()
      await mutate({
        mutation: gql`
          mutation setFixedTipV3Preferences($websiteId: ID, $tipAmount: Float) {
            setUserPreferences(websiteId: $websiteId, tipAmount: $tipAmount, tipPercentage: 0) {
              _id
              tipAmount
              tipPercentage
              cart {
                calculatedTipAmount
                amountToPay
              }
            }
          }
        `,
        optimisticResponse: {
          __typename: 'Mutation',
          setUserPreferences: {
            __typename: 'Preference',
            _id,
            tipAmount: amount,
            tipPercentage: null,
            cart: {
              __typename: 'Cart',
              calculatedTipAmount: amount,
              amountToPay: amountToPay + (amount - calculatedTipAmount)
            }
          }
        },
        variables: {websiteId, tipAmount: amount}
      })

      onSuccess()
      sendEvent<PurchaseTaxonomies['tipAmountChanged']>(EVENTS.purchase.tipAmountChanged, {
        ...eventBaseProperties,
        suggestedTip: calculatedTipAmount,
        selectedTip: amount,
        menuId: preferences?.menuId ?? ''
      })
    } catch (error) {
      onError(error)
    } finally {
      optimisticEnd()
    }
  }

  return setTipAmount
}
